import URLBuilder from '@/lib/url-builder';

export default function contentRegistrationUrl(
  urlQuerySearchParams?: URLSearchParams | null | undefined,
  urlHash?: string | null | undefined,
): string {
  const url = new URLBuilder('/registrace', urlQuerySearchParams, urlHash);
  return url.build();
}
